export default __webpack_public_path__ + "static/media/img2.b929ced7.jpg";